const zh_CN = {
    login_welcome: '欢迎!',
    // login_title: '请登录账号',
};

export default zh_CN;
